import styled from 'styled-components';

export const SeverityColor = styled.div`
    border-radius: 6px;
    width: 8px;
    height: 16px;
`;